import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyGroupHeaderModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "GroupHeader" */ 'owa-group-header/lib/components/GroupHeader');
});
export var GroupHeader = createLazyComponent(lazyGroupHeaderModule, function (m) { return m.default; });
var lazyGroupDeepLinkModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "GroupDeepLink" */ 'owa-group-deeplink/lib/components/DeeplinkActionDialog');
});
export var GroupDeepLinkDialog = createLazyComponent(lazyGroupDeepLinkModule, function (m) { return m.default; });
//# sourceMappingURL=index.js.map